import React from 'react';
import CybsHeader from '@cybs-ui/components/lib/page-header';
import {connect} from 'react-redux';
import MethodType from '../../chip/js/method-type';
import '../css/rhs-header.css';

class summaryRhs extends React.Component{

  render(){
    return[
      <CybsHeader
            breadCrumbs={[
              {
                pageTitle: this.props.secondLevelKey
              }
            ]}
            i18n={{
              ariaLabel: 'Navigation List',
              title: this.props.summary
            }}
            dataTest="header-basic"
          />,
        <MethodType/>   
        ]
      
  }
 
}

function mapStateToProps(state){
  return{
    secondLevelKey: state.lhsReducer.secondLevelKey,
    summary: state.lhsReducer.summary
  }
}

export default connect(mapStateToProps)(summaryRhs);
